import type { CertificateDetail } from '@/features/certificates/api';
import { dayLabel, TZ } from '@/pages/calendar/time';

export function identityLabel(
  identity: CertificateDetail['patient']['identity'],
) {
  if (!identity) return null;
  return identity.type === 'mykad'
    ? `MyKad ${identity.value}`
    : `Passport ${identity.value} (${identity.issuingCountry})`;
}

export function periodLabel(d: { from: string | null; to: string | null }) {
  if (!d.from) return '—';
  return d.to && d.to !== d.from
    ? `${dayLabel(d.from)} – ${dayLabel(d.to)}`
    : dayLabel(d.from);
}

/** Clinic-time date of a timestamp ("6 Oct 2026"), never the UTC day. */
export function clinicDayLabel(iso: string) {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: TZ,
  });
}

/** Clinic-time date and time with the year, as printed on the MC. */
export function issuedLabel(iso: string) {
  return new Date(iso).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: TZ,
  });
}
